import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, MoveRight } from 'lucide-react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { images } from '../assets/assets';

const NotFound = () => {

  return (
    <div className="flex flex-col min-h-screen font-lato">
      <Navbar />
      
      <main className="flex-grow flex items-center justify-center py-16 px-4 bg-[#FBFBFB]">
        <div className="max-w-[1200px] w-full flex flex-col md:flex-row items-center justify-between gap-12">
          
          {/* Left Side: Illustration */}
          <div className="w-full md:w-1/2 flex justify-center animate-in fade-in slide-in-from-left duration-700">
            <div className="relative group">
              {/* Decorative Circle Background */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#1975FF20] rounded-full blur-3xl group-hover:bg-[#1975FF30] transition-colors duration-500"></div>
              
              <img 
                src={images.NotFoundImg} 
                alt="404 - Not Found" 
                className="relative z-10 w-full max-w-[450px] h-auto object-contain transform group-hover:scale-105 transition-transform duration-500 ease-out"
              />
            </div>
          </div>

          {/* Right Side: Content */}
          <div className="w-full md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start animate-in fade-in slide-in-from-right duration-700 delay-200">
            <h1 className="text-[#1975FF] font-black text-[80px] md:text-[120px] leading-none mb-2">
              404
            </h1>
            <h2 className="text-[#1F2933] font-bold text-[24px] md:text-[36px] leading-tight mb-4">
              Oops! You've reached a dead end.
            </h2>
            <p className="text-[#5F5F5F] text-[16px] md:text-[18px] max-w-[500px] mb-8 font-openSans">
              It seems like the page you are looking for has been moved, deleted, or never existed in the first place. Don't worry, our medical team is on it!
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/"
                className="bg-[#1975FF] rounded-[10px] py-3 px-8 flex items-center justify-center gap-3 text-[16px] font-bold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-lg hover:shadow-xl group"
              >
                <Home className="w-5 h-5" />
                Back to Home
                <span className="p-1.5 bg-white rounded-full transition-transform duration-300 group-hover:translate-x-1">
                  <MoveRight color="#1975FF" className="w-4 h-4" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
